import React, { Component } from 'react';
import request from 'superagent';
import EmailValidator from "email-validator";
import { Spin } from 'antd';
import GlobalConstants from "./commons/Constants.js";
import {getUrl} from "./commons/CommonUtils.js";

class LoginPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            loginFailed: false,
            isLoggingIn: false,
            errorMsg: ''
        };
    }

    componentDidMount() {
        const path = this.props.location.pathname;
        if (path && path.indexOf("loginFailed") !== -1) {
            this.setState({loginFailed: true});
            const errorMsg = this.props.location.state ? this.props.location.state : 'Sign in failed. Please check your email address.';
            this.setState({errorMsg});
            if (sessionStorage.length !== 0) {
                this.logoutUser();
            }
        }
    }

    logoutUser = () => {
        console.log("user logout");
        request.delete('/api/removeAuthCookie').withCredentials().end();
        const url = getUrl(GlobalConstants.Service.orionUserAuth, "/signout");
        request.post(url).withCredentials().end();
        sessionStorage.clear();
    }

    handleChange = (event) => {
        this.setState({
            email: event.target.value,
            loginFailed: false
        });
    }

    login = (e) => {
        e.preventDefault();
        if (this.state.email === '' || !EmailValidator.validate(this.state.email)) {
            this.setState({loginFailed: true, errorMsg: 'Invalid email address.'});
            this.emailInput.focus();
            return;
        }
        this.setState({isLoggingIn: true});
        window.location.href = "/api/authenticate?username=" + this.state.email;
    }

    render() {
        const { isLoggingIn, loginFailed, email, errorMsg } = this.state;

        const inputClassName = isLoggingIn ? 'disabled' : '';

        return (
            <div className="pholio-main-contaner">
                <div className="pholio-header">
                    <div className="logo"></div>
                    <div className="product-name">Cloud Service Administration</div>
                </div>
                <div className="loginPageContainer">
                    <div className="loginpage">
                        <div className="loginpage-center">
                            <div className="loginpage-inside">
                                <div className="login-area">
                                    { loginFailed && <div className="error-box">{errorMsg}</div> }

                                    <h1 className="signIn-text">Sign In</h1>

                                    <div className="login-action-area">
                                        <form className="login-form" name="loginCtrl.loginForm">
                                            <div className="form-group">
                                                <label htmlFor="Email">Email Address</label>
                                                <input ref={input => this.emailInput = input}
                                                       type="email" className={inputClassName} autoFocus
                                                       value={email} disabled={isLoggingIn}
                                                       onChange={this.handleChange} name="Email" id="Email"/>
                                            </div>

                                            <div className="login-Continue-container">
                                                {isLoggingIn ?
                                                    <Spin spinning={ true } tip='Please wait...'/> :
                                                    <button className="continue-button" onClick={this.login}
                                                            disabled={isLoggingIn}>Continue</button>
                                                }
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LoginPage;


// WEBPACK FOOTER //
// ./src/LoginPage.js